import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SetupContainerComponent } from "@app/view/setup/setup-container/setup-container.component";
import { AuthGuardService } from "@app/core";
import { SkillListComponent } from "@app/view/setup/assignment/skill-list/skill-list.component";
import { SetupHomeComponent } from "@app/view/setup/setup-home/setup-home.component";
import { ZoneCreateComponent } from "@app/view/setup/resourcing/zone/zone-create/zone-create.component";
import { SorCodeListComponent } from "@app/view/setup/codes/sor-code-list/sor-code-list.component";
import { VisitTypeListComponent } from "@app/view/setup/assignment/visit-type-list/visit-type-list.component";

import { SkillDetailComponent } from "@app/view/setup/assignment/skill-detail/skill-detail.component";
import { VisitTypeDetailComponent } from "@app/view/setup/assignment/visit-type-detail/visit-type-detail.component";
import { PriorityListComponent } from "@app/view/setup/codes/priority-list/priority-list.component";
import { PlanningSegmentListComponent } from "@app/view/setup/assignment/planning-segment-list/planning-segment-list.component";
import { SkillProfileListComponent } from "@app/view/setup/assignment/skill-profile-list/skill-profile-list.component";
import { ResourceListComponent } from "@app/view/setup/resourcing/resources/resource-list/resource-list.component";
import { ResourceDetailComponent } from "@app/view/setup/resourcing/resources/resource-detail/resource-detail.component";
import { SkillProfileDetailComponent } from "@app/view/setup/assignment/skill-profile-detail/skill-profile-detail.component";
import { VisitTypeAddComponent } from "@app/view/setup/assignment/visit-type-add/visit-type-add.component";
import { TeamsComponent } from "@app/view/setup/resourcing/team/team-list/teams.component";
import { TeamsAddComponent } from "@app/view/setup/resourcing/team/teams-add/teams-add.component";
import { TeamDetailComponent } from "@app/view/setup/resourcing/team/team-detail/team-detail.component";
import { AvailabilityCodeListComponent } from "@app/view/setup/codes/availability-code-list/availability-code-list.component";
import { AvailabilityCodeDetailComponent } from "@app/view/setup/codes/availability-code-detail/availability-code-detail.component";
import { TicketCompletionCodeListComponent } from "@app/view/setup/codes/ticket-completion-code-list/ticket-completion-code-list.component";
import { ZoneMapComponent } from "@app/view/setup/resourcing/zone/zone-map/zone-map.component";
import { SystemAdminHomeComponent } from "@app/view/setup/system/system-admin-home/system-admin-home.component";
import { ResourcingHomeComponent } from "@app/view/setup/resourcing/resourcing-home/resourcing-home.component";
import { CodesHomeComponent } from "@app/view/setup/codes/codes-home/codes-home.component";
import { AssignmentHomeComponent } from "@app/view/setup/assignment/assignment-home/assignment-home.component";
import { RosterListComponent } from "@app/view/setup/resourcing/roster/roster-list/roster-list.component";
import { RosterEditComponent } from "@app/view/setup/resourcing/roster/roster-edit/roster-edit.component";
import { CyclicalSettingListComponent } from "@app/view/setup/assignment/cyclical-setting-list/cyclical-setting-list.component";
import { CyclicalHomeComponent } from "@app/view/setup/assignment/cyclical-home/cyclical-home.component";
import { CyclicalHistoryListComponent } from "@app/view/setup/assignment/cyclical-history-list/cyclical-history-list.component";
import { BookingReasonListComponent } from "@app/view/setup/codes/booking-reason-list/booking-reason-list.component";
import { WebhookAdminListComponent } from "./system/webhook-admin-list/webhook-admin-list.component";
import { GroupsComponent } from "@app/view/setup/resourcing/groups/groups.component";
import { GroupEditComponent } from "@app/view/setup/resourcing/group-edit/group-edit.component";
import { AdminGuardService } from "@app/core/auth/admin-guard.service";
import { WebhookLogComponent } from "@app/view/setup/system/webhook-log/webhook-log.component";
import { SystemConfigListComponent } from "@app/view/setup/system/system-config-list/system-config-list.component";
import { PlannerListComponent } from "@app/view/setup/resourcing/planner/planner-list/planner-list.component";
import { TimesheetCodeListComponent } from "@app/view/setup/codes/timesheet-code-list/timesheet-code-list.component";
import { AutobookVisitRulesComponent } from "@app/view/setup/assignment/autobook-visit-rules/autobook-visit-rules.component";
import { MappingPatternsComponent } from "@app/view/setup/resourcing/mapping-patterns/mapping-patterns.component";
import { SorCodeOverrideListComponent } from "@app/view/setup/codes/sor-code-override-list/sor-code-override-list.component";

const routes: Routes = [
  {
    path: "setup",
    component: SetupContainerComponent,
    data: { title: "scheduler.menu.setup" },
    canActivate: [AdminGuardService],
    children: [
      { path: "", redirectTo: "resourcing", pathMatch: "prefix" },
      { path: "home", component: SetupHomeComponent },

      {
        path: "assignment",
        component: AssignmentHomeComponent,
        children: [
          { path: "", redirectTo: "skills", pathMatch: "full" },

          // SKILLS
          { path: "skills", component: SkillListComponent },
          { path: "skills/:id", component: SkillDetailComponent },

          // SKILL PROFILES
          { path: "skillProfiles", component: SkillProfileListComponent },
          { path: "skillProfiles/:id", component: SkillProfileDetailComponent },

          // VISITS
          { path: "visits", component: VisitTypeListComponent },
          { path: "visits/create", component: VisitTypeAddComponent },
          { path: "visits/:id", component: VisitTypeDetailComponent },
          // { path: 'visit/:id/edit', component: VisitTypeEditComponent },
          // PLANNING SEGMENTS
          { path: "planningSegments", component: PlanningSegmentListComponent },
          {
            path: "autobook",
            component: CyclicalHomeComponent,
            children: [
              { path: "", redirectTo: "history", pathMatch: "prefix" },
              { path: "history", component: CyclicalHistoryListComponent },
              { path: "profiles", component: CyclicalSettingListComponent },
              { path: "visitRules", component: AutobookVisitRulesComponent }
            ]
          }
        ]
      },

      {
        path: "codes",
        component: CodesHomeComponent,
        children: [
          { path: "", redirectTo: "sor", pathMatch: "full" },

          // SCHEDULES
          { path: "sor", component: SorCodeListComponent },

          // AVAILABILITY CODES
          { path: "availability", component: AvailabilityCodeListComponent },
          {
            path: "availability/:id",
            component: AvailabilityCodeDetailComponent
          },
          // PRIORITIES
          { path: "priority", component: PriorityListComponent },

          { path: "completion", component: TicketCompletionCodeListComponent },

          { path: "bookingReasons", component: BookingReasonListComponent },
          { path: "timesheetCodes", component: TimesheetCodeListComponent },
          { path: "sorOverrides", component: SorCodeOverrideListComponent }
        ]
      },

      {
        path: "resourcing",
        component: ResourcingHomeComponent,
        children: [
          { path: "", redirectTo: "resources", pathMatch: "full" },
          { path: "planners", component: PlannerListComponent },
          // RESOURCES
          { path: "resources", component: ResourceListComponent },
          { path: "resources/:id", component: ResourceDetailComponent },
          { path: "groups", component: GroupsComponent },
          { path: "groups/:id", component: GroupEditComponent },
          { path: "mapping-patterns", component: MappingPatternsComponent },
          // TEAMS
          { path: "teams", component: TeamsComponent },
          { path: "teams/add", component: TeamsAddComponent },
          { path: "teams/:id", component: TeamDetailComponent },
          // ZONES
          { path: "zones", component: ZoneMapComponent },
          { path: "zone/create", component: ZoneCreateComponent },
          { path: "zone/map", component: ZoneMapComponent },
          {
            path: "rosters",
            component: RosterListComponent,
            data: { title: "scheduler.menu.roster" },
            canActivate: [AuthGuardService]
          },
          {
            path: "rosters/:id",
            component: RosterEditComponent,
            data: { title: "scheduler.menu.roster" },
            canActivate: [AuthGuardService]
          }
        ]
      },

      {
        path: "system",
        component: SystemAdminHomeComponent,
        children: [
          { path: "", redirectTo: "config", pathMatch: "full" },
          // WEBHOOKS
          { path: "webhooks", component: WebhookAdminListComponent },
          { path: "webhooks/:id/log", component: WebhookLogComponent },
          // SYSTEM CONFIGS
          { path: "config", component: SystemConfigListComponent }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SetupRouterModule {}
